var _circle, _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgVideoPlayerInfo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 19,
    viewBox: "0 0 19 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 9.5,
    cy: 9.5,
    r: 9.5,
    fill: "#EFF2F3"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.5 5.06L10.276 11.822H8.624L8.386 5.06H10.5ZM9.492 15.098C9.13733 15.098 8.84333 14.9907 8.61 14.776C8.386 14.552 8.274 14.2767 8.274 13.95C8.274 13.6233 8.386 13.3527 8.61 13.138C8.84333 12.914 9.13733 12.802 9.492 12.802C9.83733 12.802 10.122 12.914 10.346 13.138C10.57 13.3527 10.682 13.6233 10.682 13.95C10.682 14.2767 10.57 14.552 10.346 14.776C10.122 14.9907 9.83733 15.098 9.492 15.098Z",
    fill: "#FAA424"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgVideoPlayerInfo);
export default __webpack_public_path__ + "static/media/videoPlayerInfo.06bd43a821427a93c25f98953d166ff8.svg";
export { ForwardRef as ReactComponent };